export const provinceList = [
  {
    code: '81',
    en: {
      name: 'KRABI',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'กระบี่',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '10',
    en: {
      name: 'Bangkok',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'กรุงเทพมหานคร',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '71',
    en: {
      name: 'KANCHANABURI',
      sector: 'ภาคตะวันตก'
    },
    th: {
      name: 'กาญจนบุรี',
      sector: 'ภาคตะวันตก'
    }
  },
  {
    code: '46',
    en: {
      name: 'KALASIN',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'กาฬสินธุ์',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '62',
    en: {
      name: 'KAMPHAENG PHET',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'กำแพงเพชร',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '40',
    en: {
      name: 'KHON KAEN',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'ขอนแก่น',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '22',
    en: {
      name: 'CHANTHABURI',
      sector: 'ภาคตะวันออก'
    },
    th: {
      name: 'จันทบุรี',
      sector: 'ภาคตะวันออก'
    }
  },
  {
    code: '24',
    en: {
      name: 'CHACHOENGSAO',
      sector: 'ภาคตะวันออก'
    },
    th: {
      name: 'ฉะเชิงเทรา',
      sector: 'ภาคตะวันออก'
    }
  },
  {
    code: '20',
    en: {
      name: 'CHON BURI',
      sector: 'ภาคตะวันออก'
    },
    th: {
      name: 'ชลบุรี',
      sector: 'ภาคตะวันออก'
    }
  },
  {
    code: '18',
    en: {
      name: 'CHAI NAT',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'ชัยนาท',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '36',
    en: {
      name: 'CHAIYAPHUM',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'ชัยภูมิ',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '86',
    en: {
      name: 'CHUMPHON',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'ชุมพร',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '57',
    en: {
      name: 'CHIANG RAI',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'เชียงราย',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '50',
    en: {
      name: 'CHIANG MAI',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'เชียงใหม่',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '92',
    en: {
      name: 'TRANG',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'ตรัง',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '23',
    en: {
      name: 'TRAT',
      sector: 'ภาคตะวันออก'
    },
    th: {
      name: 'ตราด',
      sector: 'ภาคตะวันออก'
    }
  },
  {
    code: '63',
    en: {
      name: 'TAK',
      sector: 'ภาคตะวันตก'
    },
    th: {
      name: 'ตาก',
      sector: 'ภาคตะวันตก'
    }
  },
  {
    code: '26',
    en: {
      name: 'NAKHON NAYOK',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'นครนายก',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '73',
    en: {
      name: 'NAKHON PATHOM',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'นครปฐม',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '48',
    en: {
      name: 'NAKHON PHANOM',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'นครพนม',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '30',
    en: {
      name: 'NAKHON RATCHASIMA',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'นครราชสีมา',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '80',
    en: {
      name: 'NAKHON SI THAMMARAT',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'นครศรีธรรมราช',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '60',
    en: {
      name: 'NAKHON SAWAN',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'นครสวรรค์',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '12',
    en: {
      name: 'NONTHABURI',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'นนทบุรี',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '96',
    en: {
      name: 'NARATHIWAT',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'นราธิวาส',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '55',
    en: {
      name: 'NAN',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'น่าน',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '38',
    en: {
      name: 'BUENG KAN',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'บึงกาฬ',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '31',
    en: {
      name: 'BURI RAM',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'บุรีรัมย์',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '13',
    en: {
      name: 'PATHUM THANI',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'ปทุมธานี',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '77',
    en: {
      name: 'PRACHUAP KHIRI KHAN',
      sector: 'ภาคตะวันตก'
    },
    th: {
      name: 'ประจวบคีรีขันธ์',
      sector: 'ภาคตะวันตก'
    }
  },
  {
    code: '25',
    en: {
      name: 'PRACHIN BURI',
      sector: 'ภาคตะวันออก'
    },
    th: {
      name: 'ปราจีนบุรี',
      sector: 'ภาคตะวันออก'
    }
  },
  {
    code: '94',
    en: {
      name: 'PATTANI',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'ปัตตานี',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '14',
    en: {
      name: 'PHRA NAKHON SI AYUTTHAYA',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'พระนครศรีอยุธยา',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '56',
    en: {
      name: 'PHAYAO',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'พะเยา',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '82',
    en: {
      name: 'PHANGNGA',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'พังงา',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '93',
    en: {
      name: 'PHATTHALUNG',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'พัทลุง',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '66',
    en: {
      name: 'PHICHIT',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'พิจิตร',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '65',
    en: {
      name: 'PHITSANULOK',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'พิษณุโลก',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '76',
    en: {
      name: 'PHETCHABURI',
      sector: 'ภาคตะวันตก'
    },
    th: {
      name: 'เพชรบุรี',
      sector: 'ภาคตะวันตก'
    }
  },
  {
    code: '67',
    en: {
      name: 'PHETCHABUN',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'เพชรบูรณ์',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '54',
    en: {
      name: 'PHRAE',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'แพร่',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '83',
    en: {
      name: 'PHUKET',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'ภูเก็ต',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '44',
    en: {
      name: 'MAHA SARAKHAM',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'มหาสารคาม',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '49',
    en: {
      name: 'MUKDAHAN',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'มุกดาหาร',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '58',
    en: {
      name: 'MAE HONG SON',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'แม่ฮ่องสอน',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '35',
    en: {
      name: 'YASOTHON',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'ยโสธร',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '95',
    en: {
      name: 'YALA',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'ยะลา',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '45',
    en: {
      name: 'ROI ET',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'ร้อยเอ็ด',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '85',
    en: {
      name: 'RANONG',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'ระนอง',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '21',
    en: {
      name: 'RAYONG',
      sector: 'ภาคตะวันออก'
    },
    th: {
      name: 'ระยอง',
      sector: 'ภาคตะวันออก'
    }
  },
  {
    code: '70',
    en: {
      name: 'RATCHABURI',
      sector: 'ภาคตะวันตก'
    },
    th: {
      name: 'ราชบุรี',
      sector: 'ภาคตะวันตก'
    }
  },
  {
    code: '16',
    en: {
      name: 'LOP BURI',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'ลพบุรี',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '52',
    en: {
      name: 'LAMPANG',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'ลำปาง',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '51',
    en: {
      name: 'LAMPHUN',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'ลำพูน',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '42',
    en: {
      name: 'LOEI',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'เลย',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '33',
    en: {
      name: 'SI SA KET',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'ศรีสะเกษ',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '47',
    en: {
      name: 'SAKON NAKHON',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'สกลนคร',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '90',
    en: {
      name: 'SONGKHLA',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'สงขลา',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '91',
    en: {
      name: 'SATUN',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'สตูล',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '11',
    en: {
      name: 'SAMUT PRAKAN',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'สมุทรปราการ',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '75',
    en: {
      name: 'SAMUT SONGKHRAM',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'สมุทรสงคราม',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '74',
    en: {
      name: 'SAMUT SAKHON',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'สมุทรสาคร',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '27',
    en: {
      name: 'SA KAEO',
      sector: 'ภาคตะวันออก'
    },
    th: {
      name: 'สระแก้ว',
      sector: 'ภาคตะวันออก'
    }
  },
  {
    code: '19',
    en: {
      name: 'SARABURI',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'สระบุรี',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '17',
    en: {
      name: 'SING BURI',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'สิงห์บุรี',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '64',
    en: {
      name: 'SUKHOTHAI',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'สุโขทัย',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '72',
    en: {
      name: 'SUPHAN BURI',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'สุพรรณบุรี',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '84',
    en: {
      name: 'SURAT THANI',
      sector: 'ภาคใต้'
    },
    th: {
      name: 'สุราษฎร์ธานี',
      sector: 'ภาคใต้'
    }
  },
  {
    code: '32',
    en: {
      name: 'SURIN',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'สุรินทร์',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '43',
    en: {
      name: 'NONG KHAI',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'หนองคาย',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '39',
    en: {
      name: 'NONG BUA LAMPHU',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'หนองบัวลำภู',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '15',
    en: {
      name: 'ANG THONG',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'อ่างทอง',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '37',
    en: {
      name: 'AMNAT CHAROEN',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'อำนาจเจริญ',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '41',
    en: {
      name: 'UDON THANI',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'อุดรธานี',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  },
  {
    code: '53',
    en: {
      name: 'UTTARADIT',
      sector: 'ภาคเหนือ'
    },
    th: {
      name: 'อุตรดิตถ์',
      sector: 'ภาคเหนือ'
    }
  },
  {
    code: '61',
    en: {
      name: 'UTHAI THANI',
      sector: 'ภาคกลาง'
    },
    th: {
      name: 'อุทัยธานี',
      sector: 'ภาคกลาง'
    }
  },
  {
    code: '34',
    en: {
      name: 'UBON RATCHATHANI',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    },
    th: {
      name: 'อุบลราชธานี',
      sector: 'ภาคตะวันออกเฉียงเหนือ'
    }
  }
]